import { IContentProps } from './types'
import { useCallback, useRef, useState } from 'react'
import { StyledIframe, StyledIframeWrapper } from './ContentIframe.style'

const defaultHeight = 490
const ContentIframe = ({ iframeEl }: IContentProps) => {
  const [height, setHeight] = useState(defaultHeight)
  const iframeRef = useRef<HTMLIFrameElement>(null)

  const _onLoad = useCallback(() => {
    const url = new URL(iframeEl.src)

    if (iframeRef !== null && url.host === window.location.host) {
      try {
        if (iframeRef && iframeRef.current) {
          setHeight(
            iframeRef?.current?.contentWindow?.document?.body?.offsetHeight ||
              defaultHeight
          )
        }
      } catch (e) {
        /* empty */
      }
    }
  }, [iframeEl.src])

  const props: {
    height?: number
    width?: number
    css?: string
  } = {}
  let css

  if (iframeEl.height) {
    props.height = parseInt(iframeEl.height)
  }
  if (iframeEl.width) {
    props.width = parseInt(iframeEl.width)
  }
  if (iframeEl.style) {
    css = iframeEl.style.cssText
  }
  return (
    <StyledIframeWrapper theme={{ height: props.height || height, css }}>
      <StyledIframe
        title={iframeEl.title || ''}
        ref={iframeRef}
        src={iframeEl.src}
        frameBorder={iframeEl.frameBorder}
        onLoad={_onLoad}
        {...props}
      />
    </StyledIframeWrapper>
  )
}
export default ContentIframe
